import axios from 'axios';

export const publicClient = axios.create({
  headers: {
    Accept: 'application/json',
    // Authorization: `Bearer ${getCookie("access_token")}`
  }
}
);

export const isCancel = axios.isCancel;


export const cancelTokenSource = axios.CancelToken;

